<template>
  <div
    id="dvreg"
    @click="HideDropdown"
    :class="visitor ? 'page-effect visitor' : 'page-effect'"
  >
    <header v-if="!visitor && false" class="header-navbar sticky-top">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="d-md-flex align-items-center justify-content-between">
              <div class="left-logo" style="width: 100%">
                <img id="imgBanner" v-bind:src="BannerURL" alt="e2m" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- <div>{{response}}</div> -->
    <section
      v-if="EventsData && EventsData[0]"
      class="register-page-wrapper body-content event-reg-speakers mt-2"
      style="background-color: #ffffff"
    >
      <div class="container-fluid">
        <!---top back- login area -->
        <div
          v-if="!visitor"
          class="
            row
            align-items-center
            top-login-wrapper
            reg-v2-top-w
            px-lg-10
            my-0
          "
        >
          <a class="d-block back_reg_v2" v-on:click="goForLandingPage">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="17.94"
              viewBox="0 0 22 17.94"
            >
              <path
                id="back.svg"
                class="cls-1"
                d="M5684,1118.96h-17.45l7.16,6.31a0.96,0.96,0,0,1,0,1.38,0.978,0.978,0,0,1-1.38,0l-8.95-7.93a0.247,0.247,0,0,1-.09-0.04,1.053,1.053,0,0,1,0-1.43,0.631,0.631,0,0,0,.09-0.04l8.95-7.93a0.978,0.978,0,0,1,1.38,0,0.96,0.96,0,0,1,0,1.38l-7.16,6.31H5684A1,1,0,1,1,5684,1118.96Z"
                transform="translate(-5663 -1109)"
              />
            </svg>
          </a>
          <div class="col-lg-8 cent-reg-v2-name d-flex px-lg-8">
            <div class="reg-v2-left-img">
              <div class="">
                <img :src="EventsData[0].EventLogo" alt="e2m" class="rounded" />
              </div>
            </div>
            <div class="reg-v2-head pl-lg-8 pl-md-3">
              <!---name and date start-->
              <h1 class="page-head mb-0">
                {{ EventsData[0].EventFullName }}
              </h1>
              &nbsp;
              <div class="top-right-login ml-n4">
                <!-- <a
                  href="javascript:void(0);"
                  style="pointer-events: none"
                  class="event-List py-2"
                >
                  {{ EventsData[0].EventStartDateZ }} to
                  {{ EventsData[0].EventEndDateZ }} {{ EventsData[0].TimeZone
                  }}<br />
                </a> -->
                <!-- {{EventsData[0].EventDateStringLabel}}-{{EventsData[0].EventFullName}}-{{EventsData[0].EventEndTimestamp}}-{{EventsData[0].EventEndTimestamp}} -->
                <AddEventToCalendar
                  :addToCalendarLabel="EventsData[0].EventDateStringLabel"
                  :displayLabel="true"
                  :eventTitle="EventsData[0].EventFullName"
                  :eventStartTimestamp="EventsData[0].EventStartTimestamp"
                  :eventEndTimestamp="EventsData[0].EventEndTimestamp"
                />
              </div>
              <!---name and date end-->
            </div>
          </div>
          <div class="col-lg-4 pl-md-0 pr-md-8">
            <div class="top-right-login text-right hdr-btn login-ico">
              <!-- <span class="reg-v2-rig-link">
                <a
                  v-show="Config.LandingPageShowEventListLink"
                  v-on:click="goForEventList"
                  class="event-List m-0"
                  >Event List</a
                ></span
              > -->
              <!-- <span class="reg-v2-rig-link">
                <a v-on:click="goForLogin" class="login mx-0">Login</a></span
              > -->
            </div>
          </div>
        </div>
        <!------->
        <!--time start-->
        <div class="reg-v2-time-wrap p-3 my-3">
          <div class="d-flex align-items-center justify-content-center">
            <span>{{ countDownTimer }}</span>
            <p class="m-0 ml-4">
              Please complete registration within
              {{ expiry }} minutes. After {{ expiry }} minutes, the reservation
              we're holding will be released to others.
            </p>
          </div>
        </div>
        <!--time end-->
        <!-----middle-area -->
        <div class="row register-lg-form fill-white pl-lg-10 mt-0 border-top">
          <!-----left-area -->
          <div
            v-if="!visitor && !isMobileView"
            class="col-md-4 reg_left_wrapper_hld reg-v2-l-w pb-10"
          >
            <div class="row reg_v2">
              <div
                class="
                  register-page-wrapper
                  left-content
                  fill-white
                  event-reg-speakers
                  form-left-hld
                  mb-0
                  full-width
                  pt-0
                "
              >
                <ul
                  class="list-group px-md-8 mt-4"
                  v-if="RegistrationTypes.length > 1"
                >
                  <!--<li class="list-group-item complete" >Commissioner Registrant</li>
                           <li class="list-group-item complete" >President Registrant</li>
                           <li class="list-group-item current" >President Registrant 2</li>-->
                  <li
                    class="list-group-item"
                    v-for="(item, index) in RegistrationTypes"
                    :key="index"
                    :class="
                      (index == ActiveRegIndex ? 'current' : '') +
                      CompleteClass(index)
                    "
                    @click="GoToForm(index, true)"
                  >
                    {{ item.FormLabel }}
                  </li>
                </ul>
                <!--left new design 22.11.21---->
                <div v-else class="reg-le-sessdes-wrap pr-lg-10 mt-10">
                  <div class="rl-calender-page">
                    <p>{{ EventsData[0].EventStartMonth }}</p>
                    <label>{{ EventsData[0].EventStartDay }}</label>
                    <span>{{ EventsData[0].EventStartYear }}</span>
                  </div>
                  <div class="rt-bg-wrap">
                    <div class="reg-v2-head">
                      <h1 class="page-head mb-0">
                        {{ EventsData[0].EventFullName }}
                      </h1>
                    </div>
                    <div class="reg-cby">
                      <p>Event By</p>
                      <label class="mb-0">{{ clientName }}</label>
                    </div>
                  </div>
                  <div class="register_popup position-relative">
                    <div class="circle circle-cu-left"></div>
                    <div class="circle circle-cu-right"></div>
                  </div>
                  <div class="rt-bg-wrap-bott">
                    <div class="reg-cby mt-0">
                      <p>Start Time</p>
                      <label class="mb-0">{{
                        EventsData[0].EventStartDateTime
                      }}</label>
                    </div>
                    <hr />
                    <div class="reg-cby" v-if="EventStartsIn">
                      <p>Event Starts In</p>
                      <label>{{ EventStartsIn }}</label>
                    </div>

                    <!--button area start--->
                    <div class="reg-ve-btn-w d-md-flex justify-content-between">
                      <!-- <button
                        type="button"
                        class="btn reg-button px-2 text-uppercase"
                      >
                        <i class="fa fa-calendar-plus-o"></i> Add to Calender
                      </button> -->
                      <v-menu open-on-hover top offset-y min-width="200">
                        <template v-slot:activator="{ on, attrs }">
                          <button
                            type="button"
                            v-on="on"
                            v-bind="attrs"
                            class="btn reg-button px-2 text-uppercase"
                            style="background: rgb(40, 138, 242) !important"
                          >
                            <i class="fa fa-calendar-plus-o"></i> Add to
                            Calendar
                          </button>
                        </template>
                        <v-list>
                          <v-list-item-group
                            active-class="pink--text custom-radio"
                          >
                            <template v-for="item in AddToCalendarList">
                              <v-list-item
                                :key="item.Name"
                                style="min-height: 24px; padding: 0px"
                              >
                                <v-list-item-content
                                  style="cursor: pointer; padding: 0"
                                >
                                  <a
                                    class="dropdown-item py-2"
                                    style="
                                      color: #212529;
                                      font-size: 16px;
                                      font-weight: 500;
                                    "
                                    :href="
                                      AddToCalendar(EventsData[0], item.Service)
                                    "
                                    target="_blank"
                                  >
                                    {{ item.Name }}
                                  </a>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-list-item-group>
                        </v-list>
                      </v-menu>
                      <button
                        class="btn reg-button text-uppercase px-2"
                        @click.stop="ShowSocialShare"
                      >
                        <i class="fa fa-share-alt"></i> Share Link
                      </button>
                    </div>

                    <!--button area end--->
                  </div>
                </div>
                <!--left new design end22.11.21---->
                <!------>
              </div>
            </div>
            <div class="row reg_v2" v-if="Config.RegFormSideBanner">
              <div
                class="
                  register-page-wrapper
                  left-content
                  fill-white
                  event-reg-speakers
                  form-left-hld
                  mb-0
                  full-width
                  pt-0
                "
              >
                <div class="reg-le-sessdes-wrap pr-lg-10">
                  <img :src="Config.RegFormSideBanner" />
                </div>
              </div>
            </div>
          </div>
          <!------register form-->
          <div class="col-md-8 login-form-hld reg-form-drop reg-v2-r-w">
            <!--mobile only ticket slider start-->
            <div class="mobile-ticket-slider reg_v2 d-md-none">
              <!-- @afterSlide="afterSlideTab"
                ref="hooperSlide" -->
              <!-- <hooper
                :settings="hooperSettings"
                class="list-group"
                style="height: 80px"
              > -->
              <div
                v-for="(item, index) in RegistrationTypes"
                :key="index"
                class="single-attendee-ticket"
              >
                <div
                  class="list-group-item"
                  :class="
                    (index == ActiveRegIndex ? 'current' : '') +
                    CompleteClass(index)
                  "
                  @click="GoToForm(index, true)"
                >
                  {{ item.FormLabel }}
                </div>
              </div>
              <!--<hooper-navigation slot="hooper-addons"></hooper-navigation>
	<hooper-pagination
	slot="hooper-addons"
	mode="fraction"
	></hooper-pagination>-->
              <!-- </hooper> -->
            </div>
            <!--mobile ticket slider end-->
            <div class="row">
              <div class="col-lg-10 mx-auto pb-10">
                <div
                  id="dvRegForm"
                  v-bind:class="
                    'reg-right-hld mb-3 px-lg-10 px-md-4 ' + shortforCSSClass
                  "
                >
                  <div
                    class="
                      d-md-flex
                      align-items-center
                      justify-content-between
                      pb-5
                    "
                  >
                    <div>
                      <h3 class="my-2">
                        {{
                          CheckoutForm
                            ? CheckoutForm.FormTitle
                            : "Register for the event"
                        }}
                      </h3>
                    </div>
                    <!-- <div
                      style="
                        text-align: center;
                        border-radius: 10px;
                        background: #dbdbdb;
                        padding: 5px 10px;
                      "
                    >
                      <div>
                        <strong>{{ countDownTimer }}</strong>
                      </div>
                    </div> -->
                    <div>
                      <p class="small-text my-2">
                        (<span style="color: red">*</span>) Marked fields are
                        mandatory to complete.
                      </p>
                    </div>
                  </div>

                  <form
                    class="fill-white rounded p-4 p-lg-5"
                    id="regForm"
                    action="/action_page.php"
                  >
                    <div class="row form-right-hld" v-if="CheckoutForm">
                      <div class="col-md-12"></div>
                      <div
                        v-for="(field, index) in DefaultFields"
                        :key="index"
                        :class="
                          field.Type == 'group_title'
                            ? 'w-100'
                            : field.Name == 'Email' && field.Compare
                            ? `col-md-12 py-0`
                            : `col-md-${field.ColumnSize} py-0`
                        "
                      >
                        <div v-if="field.Type == 'file'" class="my-0">
                          <label style="width: 100%"
                            >{{ field.Label }}
                            <span
                              class="required"
                              style="color: red"
                              v-if="field.Mandatory"
                              >*</span
                            ></label
                          >
                          <br />

                          <v-file-input
                            type="file"
                            class="defaultField"
                            :rules="rules"
                            v-model="DefaultFields[index].filevalue"
                            color="deep-purple accent-4"
                            counter
                            placeholder="Select a file to upload"
                            prepend-icon="mdi-paperclip"
                            outlined
                            :show-size="1000"
                            :accept="field.Formats ? field.Formats : ''"
                            @click="setMaxFileLimit = field.MaxSize"
                            required
                            @change="
                              onFileChange(
                                $event,
                                DefaultFields[index],
                                field.MaxSize
                              )
                            "
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                v-if="index < 2"
                                color="deep-purple accent-4"
                                dark
                                label
                                small
                              >
                                {{ text }}
                              </v-chip>

                              <span
                                v-else-if="index === 2"
                                class="
                                  text-overline
                                  grey--text
                                  text--darken-3
                                  mx-2
                                "
                              >
                                +{{ DefaultFields[index].value.length - 2 }}
                                File(s)
                              </span>
                            </template>
                          </v-file-input>
                        </div>
                        <div
                          v-else-if="field.Name == 'Email' && field.Compare"
                          class="row my-0"
                        >
                          <div class="form-group col-md-6">
                            <label
                              >{{ field.Label }}
                              <span
                                class="required"
                                style="color: red"
                                v-if="field.Mandatory"
                                >*</span
                              ></label
                            >

                            <input
                              v-if="
                                ['email'].includes(field.Type) ||
                                ['email'].includes(field.InputType)
                              "
                              :required="field.Mandatory"
                              :type="
                                field.InputType ? field.InputType : field.Type
                              "
                              class="form-control defaultField"
                              :name="field.Name"
                              :data-validationlabel="field.Label"
                              :placeholder="field.PlaceHolder"
                              v-model="DefaultFields[index].value"
                              @blur="
                                field.Type == 'email'
                                  ? checkEmail($event, index)
                                  : void 0
                              "
                            />
                          </div>

                          <div class="form-group col-md-6">
                            <label
                              >Confirm {{ field.Label }}
                              <span
                                class="required"
                                style="color: red"
                                v-if="field.Mandatory"
                                >*</span
                              ></label
                            >

                            <input
                              v-if="
                                ['email'].includes(field.Type) ||
                                ['email'].includes(field.InputType)
                              "
                              :required="field.Mandatory"
                              :type="
                                field.InputType ? field.InputType : field.Type
                              "
                              class="form-control defaultField"
                              :name="field.Name"
                              :data-validationlabel="field.Label"
                              :placeholder="field.PlaceHolder"
                              v-model="confirmEmail"
                            />
                          </div>
                        </div>

                        <div
                          v-else-if="field.Type == 'country&state'"
                          class="row my-0"
                        >
                          <div class="form-group col-md-6">
                            <label
                              >Country
                              <span
                                class="required"
                                style="color: red"
                                v-if="field.Mandatory"
                                >*</span
                              ></label
                            >
                            <br />
                            <select
                              name="Country"
                              class="form-control defaultField"
                              :required="field.Mandatory"
                              v-model="DefaultFields[index].Country"
                              @change="setStates(DefaultFields[index].Country)"
                            >
                              <option value="" selected>Select Country</option>
                              <option
                                v-for="(option, oindex) in Countries"
                                :key="oindex"
                                :value="option"
                              >
                                {{ option.country }}
                              </option>
                            </select>
                          </div>
                          <div class="form-group col-md-6">
                            <label
                              >State
                              <span
                                class="required"
                                style="color: red"
                                v-if="field.Mandatory"
                                >*</span
                              ></label
                            >
                            <br />
                            <select
                              name="State"
                              class="form-control defaultField"
                              :required="field.Mandatory"
                              v-model="DefaultFields[index].State"
                            >
                              <option value="" selected>Select State</option>
                              <option
                                v-for="(option, oindex) in States"
                                :key="oindex"
                                :value="option"
                              >
                                {{ option }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div
                          v-else-if="field.Type == 'group_title'"
                          class="form-group"
                          v-html="field.Label"
                        ></div>
                        <div class="form-group" v-else>
                          <label
                            >{{ field.Label }}
                            <span
                              class="required"
                              style="color: red"
                              v-if="field.Mandatory"
                              >*</span
                            ></label
                          >
                          <br />
                          <VuePhoneNumberInput
                            v-if="field.Type == 'phone'"
                            :default-country-code="
                              DefaultFields[index].PhoneCountryCode
                            "
                            v-model="DefaultFields[index].value"
                            :name="field.Name"
                            :data-validationlabel="field.Label"
                            :required="field.Mandatory"
                            :preferredCountries="['US', 'GB', 'SG', 'IN']"
                            @update="setPhoneCode($event, index)"
                          />
                          <input
                            v-if="
                              ['text', 'email'].includes(field.Type) ||
                              ['text', 'email'].includes(field.InputType)
                            "
                            :required="field.Mandatory"
                            :type="
                              field.InputType ? field.InputType : field.Type
                            "
                            class="form-control defaultField"
                            :name="field.Name"
                            :data-validationlabel="field.Label"
                            :placeholder="field.PlaceHolder"
                            v-model="DefaultFields[index].value"
                            @blur="
                              field.Type == 'email'
                                ? checkEmail($event, index)
                                : void 0
                            "
                          />
                          <input
                            v-if="
                              ['number'].includes(field.Type) ||
                              ['number'].includes(field.InputType)
                            "
                            :required="field.Mandatory"
                            :type="
                              field.InputType ? field.InputType : field.Type
                            "
                            class="form-control defaultField"
                            :name="field.Name"
                            :data-validationlabel="field.Label"
                            :placeholder="field.PlaceHolder"
                            v-model="DefaultFields[index].value"
                            @blur="
                              field.Type == 'email'
                                ? checkEmail($event, index)
                                : void 0
                            "
                          />
                          <textarea
                            v-if="
                              field.Type == 'textarea' ||
                              field.InputType == 'textarea'
                            "
                            :required="field.Mandatory"
                            class="form-control defaultField"
                            :name="field.Name"
                            :data-validationlabel="field.Label"
                            :placeholder="field.PlaceHolder"
                            v-model="DefaultFields[index].value"
                          >
                          </textarea>
                          <div
                            v-if="field.Type == 'profilepicture'"
                            class="d-none"
                          >
                            <img
                              style="
                                width: 45px;
                                float: left;
                                padding: 0;
                                height: 45px;
                              "
                              class="col-md-4"
                              v-if="DefaultFields[index].value"
                              :src="DefaultFields[index].value"
                            />
                            <input
                              id="fuProfile"
                              class="form-control col-md-8 defaultField"
                              type="file"
                              :required="field.Mandatory"
                              :name="field.Name"
                              :data-validationlabel="field.Label"
                              @change="
                                onFileChange($event, DefaultFields[index])
                              "
                              accept="image/*"
                            />
                          </div>
                          <select
                            v-if="
                              field.Type == 'select' ||
                              field.InputType == 'select'
                            "
                            :name="field.Name"
                            :data-validationlabel="field.Label"
                            class="form-control defaultField"
                            :required="field.Mandatory"
                            v-model="DefaultFields[index].value"
                          >
                            <option value="" selected>Select</option>
                            <option
                              v-for="(option, oindex) in field.Options"
                              :key="oindex"
                              :value="option"
                            >
                              {{ option }}
                            </option>
                          </select>
                          <v-select
                            v-if="
                              field.Type == 'multiselect' ||
                              field.InputType == 'multiselect'
                            "
                            v-model="DefaultFields[index].value"
                            :items="DefaultFields[index].Options"
                            :data-validationlabel="field.Label"
                            :name="field.Name"
                            :required="field.Mandatory"
                            class="defaultField"
                            chips
                            multiple
                            solo
                          ></v-select>
                          <div
                            v-if="
                              field.Type == 'radio' ||
                              field.InputType == 'radio'
                            "
                            :class="`defaultField radioFields ${
                              field.Mandatory ? 'required' : ''
                            }`"
                          >
                            <div
                              class="form-check form-check-inline"
                              v-for="(option, oindex) in field.Options"
                              :key="oindex"
                            >
                              <label class="form-check-label">
                                <input
                                  :type="
                                    field.InputType
                                      ? field.InputType
                                      : field.Type
                                  "
                                  :name="field.Name"
                                  :data-validationlabel="field.Label"
                                  class="form-check-input"
                                  :value="option"
                                  :required="field.Mandatory"
                                  v-model="DefaultFields[index].value"
                                />
                                {{ option }}
                              </label>
                            </div>
                          </div>
                          <div
                            class="form-check"
                            v-if="field.Type == 'checkbox'"
                          >
                            <label class="form-check-label">
                              <input
                                v-if="
                                  field.Type == 'checkbox' ||
                                  field.InputType == 'checkbox'
                                "
                                :type="
                                  field.InputType ? field.InputType : field.Type
                                "
                                :name="field.Name"
                                :data-validationlabel="field.Label"
                                :required="field.Mandatory"
                                class="form-check-input defaultField"
                                v-model="DefaultFields[index].value"
                              />
                              {{ field.Label }}
                            </label>
                          </div>
                        </div>
                      </div>
                      <!-- Extra form start-->
                      <div v-show="IsShowLongForm" class="col-md-12">
                        <vue-form-generator
                          :schema="schema"
                          :model="model"
                          :options="formOptions"
                        ></vue-form-generator>
                      </div>
                      <div class="col-md-12 button-area">
                        <div
                          v-if="PreSignupFields.HTMLbody"
                          id="text_59"
                          v-html="PreSignupFields.HTMLbody"
                          class="form-html"
                          data-component="text"
                        ></div>
                        <label
                          v-if="PreSignupFields.HTMLbody"
                          for="chkTermsAndConditions"
                        >
                          <input
                            type="checkbox"
                            required
                            class=""
                            name="TermsAndConditions"
                            id="chkTermsAndConditions"
                            value="I accept "
                            style="margin-right: 10px"
                          />
                          <span
                            v-html="PreSignupFields.AcceptanceDisplayText"
                          ></span>
                          <!-- {{ PreSignupFields.AcceptanceDisplayText }} -->
                        </label>
                        <br v-if="PreSignupFields.OptInOne" />
                        <label
                          v-if="PreSignupFields.OptInOne"
                          for="chkOptInONE"
                        >
                          <input
                            type="checkbox"
                            :required="PreSignupFields.OptInOneIsRequired"
                            name="OptInONECheckBox"
                            id="chkOptInONE"
                            :value="PreSignupFields.OptInOne"
                            style="margin-right: 10px"
                          />
                          <span v-html="PreSignupFields.OptInOne"></span>
                        </label>
                        <br v-if="PreSignupFields.OptInTwo" />
                        <label
                          v-if="PreSignupFields.OptInTwo"
                          for="chkOptInTwo"
                        >
                          <input
                            type="checkbox"
                            :required="PreSignupFields.OptInTwoIsRequired"
                            name="OptInTwoCheckBox"
                            id="chkOptInTwo"
                            :value="PreSignupFields.OptInTwo"
                            style="margin-right: 10px"
                          />
                          <span v-html="PreSignupFields.OptInTwo"></span>
                        </label>

                        <div style="height: 44px">
                          <div :class="buttonWrapperClass">
                            <button
                              type="button"
                              class="
                                btn btn-defult-cancle
                                text-uppercase
                                mr-md-2
                              "
                              @click.prevent="clearform()"
                              tabindex="-1"
                            >
                              CLEAR FORM
                            </button>
                            <!-- <button
                                    id="btnRegister"
                                    type="submit"
                                    class="btn reg-button text-uppercase ml-0"
                                    @click.prevent="SaveUserRegistration()"
                                    style="background-color: rgb(20, 200, 41)"
                                    >
                                    {{ SubmitButtonText }}
                                    </button> -->
                            <button
                              v-if="ActiveRegIndex"
                              id="btnRegister"
                              @click.prevent="gopreviousForm()"
                              class="
                                btn btn-defult-cancle
                                text-uppercase
                                mr-md-2
                              "
                            >
                              PREVIOUS FORM
                            </button>
                            <button
                              v-if="
                                ActiveRegIndex + 1 == RegistrationTypes.length
                              "
                              id="btnRegister"
                              @click.prevent="submitForms()"
                              class="btn reg-button text-uppercase ml-0"
                              style="background-color: rgb(20, 200, 41)"
                            >
                              {{
                                Config.SubmitButtonDisplaylabel
                                  ? Config.SubmitButtonDisplaylabel
                                  : "SUBMIT"
                              }}
                            </button>
                            <button
                              v-else
                              id="btnRegister"
                              @click.prevent="saveAndContinue(1)"
                              class="btn reg-button text-uppercase ml-0"
                              style="background-color: rgb(20, 200, 41)"
                            >
                              SAVE & CONTINUE
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- extra form ends -->
                    </div>
                    <div class="row form-right-hld" v-else>
                      <h3 class="no_form_text">{{ NoFormText }}</h3>
                      <div class="col-md-12"></div>
                      <div class="clsButtonclass-new reg-ve-btn-w">
                        <!-- <button
                                 v-if="RegistrationTypes[ActiveRegIndex-1]"
                                 @click.prevent="ActiveRegIndex--;getStaticFieldSettings();"
                                 class="btn btn-defult-cancle text-uppercase mr-md-2"
                                 > Previous Form
                                 </button>  
                                 <button
                                 v-if="ActiveRegIndex+1<=RegistrationTypes.length && !RegistrationTypes[ActiveRegIndex+1]"
                                 @click.prevent="submitForms();"
                                 class="btn reg-button text-uppercase mr-md-2"
                                 > Submit Form
                                 </button>                          
                                 <button
                                 v-if="RegistrationTypes[ActiveRegIndex+1]"
                                 @click.prevent="ActiveRegIndex++;getStaticFieldSettings();"
                                 class="btn btn-defult-cancle text-uppercase mr-md-2"
                                 > Next Form
                                 </button> -->
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
        display: none;
      "
    >
      <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
      <div class="loader">
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </div>
      <!-- </p> -->
    </div>
    <!-- Success Modal -->
    <div class="modal fade all-modal" id="success-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <!-- data-dismiss="modal"-->
            <button
              type="button"
              style="margin-top: -10"
              aria-label="Close"
              ref="close_modal"
              class="close"
              @click="GreatClicked"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <span
              class="
                success-icon
                d-flex
                justify-content-center
                align-items-center
              "
            >
              <img src="../assets/Images/icons/tick.svg" />
            </span>
            <p>
              <strong>Registration Completed Successfully!</strong>
            </p>
            <p>You will receive a confirmation email with your login link.</p>
            <p>
              <strong>Please save your confirmation email.</strong>
            </p>
            <p>
              If you do not receive the email, please check your
              <span style="color: #ff0000">spam folder</span> or contact event
              planner.
            </p>
            <p>
              <span
                data-dismiss="modal"
                class="btn-pink sussecc-btn"
                @click="GreatClicked"
                >Great!</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Success Modal Ends-->
    <!-- Othe msg  Modal -->
    <div class="modal fade all-modal" id="Othermsg-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg">
              This email is already registered, please sign-up with a different
              email.
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Othe msg  Modal Ends-->
    <!---Payment modal start-->
    <!-- Modal -->
    <div
      class="modal fade"
      id="payment-popup"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content payment-popup">
          <!---header start -->
          <div class="modal-header">
            <div
              class="
                d-flex
                justify-content-between
                align-items-center
                top-p-header
              "
            >
              <div class="left-side">
                <p>Paying To</p>
                <!-- <h3>{{ clientName }}</h3> -->
                <h3>{{ Config.PayingTo ? Config.PayingTo : clientName }}</h3>
              </div>
              <div class="right-side">
                <img
                  id="imgHostLogo"
                  v-if="Config.PayingToLogo"
                  v-bind:src="Config.PayingToLogo"
                  alt="e2m"
                />
                <!-- <img src="../assets/Images/neche.png" /> -->
              </div>
            </div>
          </div>
          <!---header end ---->
          <div class="text-center alert alert-success mt-3" style="">
            <span style="font-weight: bold">Up Next!</span><br />
            <span> Registration done, please proceed to Pay Now </span>
          </div>
          <div class="modal-body pt-4">
            <div class="p-plan-box total-p-price">
              <span
                id="spntotalPrice"
                class="p-plan-name"
                style="width: 70%; padding-right: 15px; word-break: break-word"
                >{{ productName }}</span
              >
              <span>{{ checkoutCurrency }}{{ ItemPrice }}</span>
            </div>
            <div class="modal-footer text-center mt-4 paymentFooter">
              <!-- <div v-if="PaymentSource.toLowerCase() == 'paypal'">
                <PayPal
                  :amount="ItemPrice.replace('$', '')"
                  :currency="PaypalCurrency"
                  :client="PPcredentials"
                  :env="PaypalEnv"
                  v-on:payment-completed="PPPcomplete"
                  v-on:payment-cancelled="PPPcanceled"
                  :invoice-number="`${customerEmail}#OA_UAT#${evntId}#${clientID}`"
                >
                </PayPal>
              </div> -->
              <div>
                <stripe-checkout
                  ref="checkoutRef"
                  :pk="publishableKey"
                  :lineItems="lineItems"
                  :successUrl="successUrl"
                  :cancelUrl="cancelUrl"
                  :mode="mode"
                  :clientReferenceId="clientReferenceId"
                  :customerEmail="customerEmail"
                >
                  <template slot="checkout-button" style="width: 100%">
                    <button
                      id="btnStripePayment"
                      @click.prevent="checkout()"
                      class="reg-button text-uppercase mb-2"
                    >
                      Proceed To Pay<i class="fa fa-external-link"></i>
                    </button>
                  </template>
                </stripe-checkout>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.payment-popup .modal-body .p-plan-box.total-p-price {
  border-top: 0px;
}
.paymentFooter div {
  width: 100%;
}
#dvreg .field-wrap .combobox {
  overflow-y: auto;
  height: 5em;
}

#dvreg .field-wrap .combobox .info {
  position: relative;
  color: #fff;
}
#dvreg .field-wrap .combobox .info:before {
  content: "" !important;
  color: #000;
  z-index: 1;
}
#dvreg .info {
  background-color: #fff !important;
  border-color: #fff !important;
  color: #000 !important;
}
/* .vue-form-generator .form-group:nth-child(4) span {
font-size: 22px;
font-weight: bold;
} */
.vue-form-generator .form-group:nth-child(13) span {
  /*font-size: 22px;*/
}
.vue-form-generator .form-group:nth-child(14) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px 0 0 !important;
}
.vue-form-generator .form-group:nth-child(15) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px !important;
}

.vue-form-generator .form-group:nth-child(16) {
  float: left;
  width: 33.33% !important;
  padding: 0 0 0 5px !important;
}

.vue-form-generator .form-group:nth-child(17) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px 0 0 !important;
}
.vue-form-generator .form-group:nth-child(18) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px !important;
}

.vue-form-generator .form-group:nth-child(19) {
  float: left;
  width: 33.33% !important;
  padding: 0 0 0 5px !important;
}

.vue-form-generator .form-group:nth-child(20) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px 0 0 !important;
}
.vue-form-generator .form-group:nth-child(21) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px !important;
}

.vue-form-generator .form-group:nth-child(22) {
  float: left;
  width: 33.33% !important;
  padding: 0 0 0 5px !important;
}
.clsButtonclass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.clsButtonclass-new {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: 0.5s;
}

.page-effect .col-md-6 .form-group {
  margin-bottom: 0px;
}
.reg-right-hld .reg-button {
  width: auto !important;
}
/* span[text="Personal Details"] {
color: red;
} */
/* Multi select drop down style */
.multiselect {
  width: 200px;
}

.selectBox {
  position: relative;
}

.selectBox select {
  width: 100%;
  font-weight: bold;
}

.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

#checkboxes {
  display: none;
  border: 1px #dadada solid;
}

#checkboxes label {
  display: block;
}

#checkboxes label:hover {
  background-color: #1e90ff;
}
.clsspecialization select:focus {
  border: none;
  box-shadow: inherit;
}

.top-right-login.hdr-btn {
  padding: 8px 0 !important;
}
/* Multi select drop down style ends */
@media only screen and (max-width: 768px) {
  .clsButtonclass {
    flex-direction: column;
  }
  .clsButtonclass button {
    width: 100% !important;
    margin-top: 12px;
    margin-left: 0 !important;
  }
  .vue-form-generator .form-group:nth-child(14),
  .vue-form-generator .form-group:nth-child(15),
  .vue-form-generator .form-group:nth-child(16),
  .vue-form-generator .form-group:nth-child(17),
  .vue-form-generator .form-group:nth-child(18),
  .vue-form-generator .form-group:nth-child(19),
  .vue-form-generator .form-group:nth-child(20),
  .vue-form-generator .form-group:nth-child(21),
  .vue-form-generator .form-group:nth-child(22) {
    width: 100% !important;
    padding: 0 0px 0 0 !important;
  }
  .top-login-wrapper .top-right-login a.event-List {
    margin-left: 0 !important;
  }
  .top-login-wrapper .top-right-login.hdr-btn {
    padding-bottom: 0 !important;
  }
}

.overSelect {
  top: 10px;
  left: 15px;
}
#checkboxes {
  position: absolute;
  border: 0;
  box-shadow: 0px 9px 12px 1px rgba(0, 0, 0, 0.14);
}
.no_form_text {
  margin: 10% auto;
}
@media (max-width: 768px) {
  .register-page-wrapper .container {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>
<script>
import Vue from "vue";
import jQuery from "jquery";
import APIs from "@/components/APIInit";
let $ = jQuery;
//import db from "../components/firebaseInit";
import router from "../router";
import { bus } from "@/main";
var self;
// import Vue from "vue";
// import VueMoment from "vue-moment";
import moment from "moment-timezone";
import firebase from "firebase";
import axios from "axios";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
// import store from "../store";
//import store from "../store";
import { StripeCheckout } from "vue-stripe-checkout";
//"vue-paypal-checkout": "^3.2.0",
//import PayPal from "vue-paypal-checkout";
import AddEventToCalendar from "@/components/AddToCalendar.vue";
//import common from "@/common";
// import {
//   Hooper,
//   Slide,
//Pagination as HooperPagination,
//Navigation as HooperNavigation,
// } from "hooper";
let countDownTimerInterval = null;
let eventStartTimerInterval = null;
const storageRef = firebase;
let DynamicInputs = {};
Vue.use(VueFormGenerator);
export default {
  components: {
    StripeCheckout,
    //PayPal,
    // Hooper,
    // Slide,
    AddEventToCalendar,
    VuePhoneNumberInput,
  },
  props: {
    regEventId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      confirmEmail: "",
      rules: [
        (value) =>
          !value ||
          value.size < self.setMaxFileLimit * 1024 * 1024 ||
          " File size should be less than " + self.setMaxFileLimit + "MB!",
      ],
      setMaxFileLimit: "",
      AllowRegistration: true,
      postToCRM: false,
      hostLogo: "",
      ItemPrice: "$0",
      productName: "",
      RegTicketType: "",
      /******************** PAYPAL ******************************************************/
      PPPitems: [
        {
          name: "",
          description: "",
          quantity: "1",
          price: "",
          currency: "USD",
          customerEmail: "",
          instanceId: "OA_UAT",
          clientId: "",
          evntId: "",
          eventName: "",
          clientName: "",
          eventcollectionname: "",
        },
      ],
      PaypalCurrency: "USD",
      PaypalEnv: "sandbox",
      PPcredentials: {
        sandbox:
          "AWdnWJe82bnGuYfCp6ghesAJEMG4l2oVRsrNWQlHFLJjgieTr-Cm_s-4tnJdoRa6Hp6FZlelrWPycKCC", //E2m client id
        production: "",
      },
      /***********************STRIPE**************************************************** */
      Payingto: "E2M Live",
      PaymentStatus: "PENDING",
      PaymentSource: "STRIPE",
      enablePaymentPop: true,

      loading: false,
      //publishableKey:"sk_test_51HSEkxJy5CUjqeXaiJrUkCGCm6iDl7yY0DFcJyM1YpWZAszFOd4fZzAonQZMHL57bAV7FogyXHMpWIuJixyjGosP0082HUE4ZE",//TEST
      publishableKey:
        "pk_test_51HSEkxJy5CUjqeXa6XpfGrMFYzhhHq2wXnskSEBb8fqdmmjKnE8ZcB6i0VueYE9Y5SLObgqIiSdBxCvARZDRFCfD000UNXug3y", //LIVE
      //publishableKey:"pk_live_yR0upxE0W5Xzq3lA0td0yxQ7",
      // publishableKey:
      //   "pk_test_51HSEkxJy5CUjqeXa6XpfGrMFYzhhHq2wXnskSEBb8fqdmmjKnE8ZcB6i0VueYE9Y5SLObgqIiSdBxCvARZDRFCfD000UNXug3y", // live key:- "pk_live_yR0upxE0W5Xzq3lA0td0yxQ7",
      lineItems: [
        {
          price: "",
          quantity: 1,
        },
      ],
      mode: "payment",
      successUrl: location.origin + "/regpaymentSuccess",
      cancelUrl: location.origin + "/regpaymentFailure",
      customerEmail: "",
      clientReferenceId: "",
      /*************************************************************************** */

      ShowEventListLink: true,
      AcceptanceDisplayText: "I Accept",
      AcceptanceValidationDisplayLabel: "Please accept terms and condiotions.",
      FormType: "Free",
      SubmitButtonText: "Complete Registration",
      //Pre signup------------------------------------------------
      HTMLbody: "",
      RequirePresignupAcceptance: false,
      OptInOne: "",
      OptInOneIsRequired: false,
      OptInTwo: "",
      OptInTwoIsRequired: false,
      //default fields---------------------------------------------

      //-----------------------------------------------------------

      BannerURL: "",
      expanded: false,
      btntextColor: "black",
      btnBackColor: "#ef222b",
      //-------Form generator []-----------------------------------------
      uploadedProfilePicturePath: "",
      getDynamincfieldsFromDB: false,
      model: DynamicInputs,

      schema: {
        fields: [],
      },

      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateBeforeSubmit: true,
      },
      fields: [],
      fieldData: [],
      FormId: "ARROW",
      FormJson: "",
      shortforCSSClass: "",
      clientID: "",
      visitor: false,
      redirectToLogin: false,
      email: "",
      evntId: "",
      eventName: "",
      clientName: "",
      clientLogo: null,
      hostName: "",
      eventcollectionname: "",
      IsShowLongForm: true,
      EventsData: [],
      reg: /^(([^<>()/[\]//.,;:\s@"]+(\.[^<>()/[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      date: moment.tz("2020-06-26 00:00", "Asia/Calcutta"),
      RegistrationTypes: [],
      ActiveRegIndex: 0,
      CheckoutForms: null,
      CheckoutForm: null,
      DefaultFields: [],
      PreSignupFields: null,
      Countries: [],
      States: [],
      checkoutPice: 0,
      checkoutCurrency: "",
      FilledForms: [],
      NoFormText: "Form Loading...",
      Config: {
        PayingToLogo: this.clientLogo,
        RegFormSideBanner: null,
        SubmitButtonDisplaylabel: "SUBMIT",
        PayingTo: this.clientName,
        LandingPageShowHostedByPanel: false,
        LandingPageShowEventListLink: false,
      },
      countDownTimer: null,
      countDownTimerLabel: null,
      bundleId: "",
      expiry: 0,
      isMobileView: true,
      // hooperSettings: {
      //   vertical: false,
      //   autoPlay: false,
      //   centerMode: true,
      //   itemsToShow: 1.5,
      //   itemsToSlide: 1,
      //   mouseDrag: true,
      //   wheelControl: false,
      //   keysControl: false,
      //   shortDrag: false,
      // breakpoints: {
      //   0: {
      //     itemsToShow: 1.5,
      //   },
      //   300: {
      //     itemsToShow: 1.5,
      //   },
      //   400: {
      //     itemsToShow: 2.5,
      //   },
      //   768: {
      //     itemsToShow: 6,
      //   },
      //   1024: {
      //     itemsToShow: 8,
      //   },
      //   1366: {
      //     itemsToShow: 10,
      //   },
      //   1440: {
      //     itemsToShow: 12,
      //   },
      //   4000: {
      //     itemsToShow: 14,
      //   },
      // },
      // },
      getCheckoutFormsRetryCount: 0,
      AddToCalendarList: [
        { Name: "Google", Service: "google" },
        { Name: "Apple", Service: "apple" },
        { Name: "Yahoo", Service: "yahoo" },
        { Name: "Outlook", Service: "outlook" },
        { Name: "Download", Service: "stream" },
      ],
      buttonWrapperClass: "clsButtonclass-new reg-ve-btn-w btn-fixed-p",
      EventStartsIn: null,
      redirect_url: "",
      auto_login: false,
      join_url: "",
      response: "",
    };
  },
  watch: {
    file: function (val) {
      alert(val);
    },
    redirectToLogin(val) {
      if (val) {
        self.autoLoginAfterReg();
      }
    },
  },
  computed: {},
  beforeCreate() {
    //   setTimeout(() => {
    //     setTimeout(() => {
    //       setTimeout(() => {
    //         $("#app").addClass("full-screen");
    //       }, 100);
    //       $("#app").addClass("full-screen");
    //     }, 100);
    //     $("#app").addClass("full-screen");
    //   }, 100);
    //   $("#app").addClass("full-screen");
    //   $("#topmenu").hide();
    //   $("#leftmenu").hide();
  },
  created() {
    self = this;
    self.countDownTimer = null;
    clearInterval(countDownTimerInterval);
    clearInterval(eventStartTimerInterval);
    self.isMobileView = self.isMobile();
    $(window).resize(function () {
      self.isMobileView = self.isMobile();
    });
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });
    $("#success-modal").modal("hide");
    //self.$refs.close_modal.click();
    $(document.body).scroll(function () {
      if (
        $(this).scrollTop() + $(this).innerHeight() >=
        $(this)[0].scrollHeight
      ) {
        //alert("reached to bottom");
        self.buttonWrapperClass = "clsButtonclass-new reg-ve-btn-w";
      } else {
        //alert("not reached to bottom");
        self.buttonWrapperClass = "clsButtonclass-new reg-ve-btn-w btn-fixed-p";
      }
    });
  },
  async mounted() {
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
    //self.showLoader();
    bus.$emit("toggleLoader", true);
    if (!self.$route.params.bundleId) {
      if (self.$store.state.publicEventCollection) {
        router.push({
          path: "/home",
        });
      } else if ((self.evntId = self.$route.params.e)) {
        router.push({
          path: "/eventv3/" + self.$route.params.e,
        });
      } else {
        router.push({
          path: "/register",
        });
      }
    }
    self.EventsData = [];
    self.evntId = self.$route.params.e;

    self.successUrl = location.origin + "/regpaymentSuccess/" + self.evntId;

    var visitor = self.$route.params.visitor;
    self.bundleId = self.$route.params.bundleId
      ? self.$route.params.bundleId
      : "";
    self.expiry = self.$route.params.expiry ? self.$route.params.expiry : 0;
    self.RegistrationTypes = self.$route.params.regTypes
      ? self.$route.params.regTypes
      : [];
    //self.startCountDownTimer();
    self.checkoutPice = self.$route.params.checkoutPice
      ? self.$route.params.checkoutPice
      : [];
    self.ItemPrice = `${self.checkoutPice}`;
    self.productName = self.RegistrationTypes.map(
      (item) => item.RegistrationType
    ).toString();
    if (self.$route.params.redirect_url) {
      self.redirect_url = self.$route.params.redirect_url;
      //alert(self.redirect_url);
    }
    if (self.$route.params.auto_login) {
      self.auto_login = self.$route.params.auto_login;
      //alert(self.auto_login);
    }

    if (visitor == "visitor") {
      self.visitor = true;
    }
    if (self.regEventId) {
      self.evntId = self.regEventId;
      self.visitor = true;
    }
    //alert(self.visitor);
    console.log(self.evntId);
    axios
      .get(
        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT/Defaults/CountryState.json"
      )
      .then((res) => {
        if (res.status == 200) self.Countries = res.data.countries;
      });

    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      self.hostName = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
    }
    var path;
    console.log(self.hostName);
    if (self.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }

    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + self.hostName + ".json?alt=media"
      )
      .then(async (res) => {
        if (res && res.data && !self.visitor) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        self.clientName = res.data.ClientName;
        self.clientLogo = res.data.LoginAssets.Logo;
        self.eventcollectionname = "OA_UAT_" + self.clientID + self.evntId;

        axios
          .get(
            APIs.EventBrandingJsonData +
              "?iid=OA_UAT" +
              "&cid=" +
              self.clientID +
              "&eid=" +
              self.evntId
          )
          .then(async (res) => {
            debugger;
            self.item = res.data.result;
            self.postToCRM =
              res.data.result.postToCRM == undefined
                ? false
                : res.data.result.postToCRM;
            if (res.data.result.ClientInfo) {
              self.desktopBanner =
                res.data.result.ClientInfo.EventListAssets.banner2048x88;
              self.mobileBanner =
                res.data.result.ClientInfo.EventListAssets.banner750x103;
              // self.BannerURL =
              //   res.data.result.ClientInfo.EventListAssets.banner2048x88;
            }
            // else {
            //   self.BannerURL == "";
            // }
            self.initScreen();
            var dateFormat = require("dateformat");

            console.log(res.data.result.EventInfo.EventFullName);
            var obj = new Object();

            obj.eventId = self.evntId;
            obj.EventFullName = res.data.result.EventInfo.EventFullName;
            obj.IsPublished = res.data.result.EventInfo.IsPublished;
            obj.TimeZone = res.data.result.EventInfo.TimeZone;
            self.eventName = res.data.result.EventInfo.EventFullName;
            self.AllowRegistration =
              res.data.result.EventInfo.AllowRegistration;
            //-----------------------------------------------------------------------
            if (self.AllowRegistration == false) {
              var str = res.data.result.EventInfo.EventFullName.replace(
                / /g,
                "_"
              );
              var str2 = str.replace(/%20/g, " ");

              router.push({
                path: "/event/" + self.evntId + "/" + str2,
              });
            }
            //-------------------------------------------------------------------
            //----------------------------------------MetaTag-------------------------------------------------------------------------------------------------
            document.title =
              res.data.result.EventInfo.EventFullName + " - " + self.clientName;

            var link = document.createElement("meta");
            link.setAttribute("property", "description");
            link.content = res.data.result.EventInfo.Description;
            document.getElementsByTagName("head")[0].appendChild(link);

            $("head").append(
              '<meta name="description" content="' +
                res.data.result.EventInfo.Description +
                '">'
            );

            $("head").append(
              '<meta property="og:title" content="' +
                res.data.result.EventInfo.EventFullName +
                '">'
            );

            $("head").append(
              '<meta property="og:description" content="' +
                res.data.result.EventInfo.Description +
                '">'
            );

            $("head").append(
              '<meta property="og:image" content="' + self.BannerURL + '">'
            );

            $("head").append(
              '<meta property="og:url" content="' + self.hostName + '">'
            );
            //-------------------------------------------------------------------------------------------------------------
            obj.EventTimezoneZ = moment.tz.guess();
            obj.EventLogo = res.data.result.EventInfo.EventLogo;
            obj.EventBannerShare = res.data.result.EventInfo.EventBannerShare;
            obj.Description = res.data.result.EventInfo.Description;
            // obj.EventStartDate = dateFormat(
            //   res.data.result.EventInfo.EventStartDate,
            //   "mmm dd, hh:MM TT"
            // );

            // obj.EventEndDate = dateFormat(
            //   res.data.result.EventInfo.EventEndDate,
            //   "mmm dd, hh:MM TT"
            // );

            obj.EventStartDateZ = self.GetTimeByZone(
              res.data.result.EventInfo.EventStartDate,
              res.data.result.EventInfo.TimeZone
            );
            obj.EventStartTimestamp = parseInt(
              obj.EventStartDateZ.getTime() / 1000
            );
            obj.EventStartDateTime = dateFormat(
              obj.EventStartDateZ,
              "mmm dd, yyyy hh:MM TT"
            );
            obj.EventStartYear = dateFormat(obj.EventStartDateZ, "yyyy");
            obj.EventStartMonth = dateFormat(obj.EventStartDateZ, "mmm");
            obj.EventStartDay = dateFormat(obj.EventStartDateZ, "dd");
            obj.EventStartDateZ = dateFormat(
              obj.EventStartDateZ,
              "mmm dd, hh:MM TT"
            );
            obj.EventEndDateZ = self.GetTimeByZone(
              res.data.result.EventInfo.EventEndDate,
              res.data.result.EventInfo.TimeZone
            );
            obj.EventEndTimestamp = parseInt(
              obj.EventEndDateZ.getTime() / 1000
            );

            obj.EventEndDateZ = dateFormat(
              obj.EventEndDateZ,
              "mmm dd, hh:MM TT"
            );
            obj.EventStartDate = dateFormat(
              obj.EventStartDateZ,
              "mmm dd, hh:MM TT"
            );
            obj.EventEndDate = dateFormat(
              obj.EventEndDateZ,
              "mmm dd, hh:MM TT"
            );

            obj.EventDateStringLabel =
              obj.EventStartDate.substr(0, 7) != obj.EventEndDate.substr(0, 7)
                ? obj.EventStartDate +
                  " to " +
                  obj.EventEndDate +
                  " " +
                  obj.EventTimezoneZ
                : obj.EventStartDate + " " + obj.EventTimezoneZ;
            self.EventsData.push(obj);
            //------------------------------------------------------
            self.ClientName = res.data.result.HostInfo.Name;
            self.clientLogoUrl = res.data.result.HostInfo.Logo;
            self.clientProfile = res.data.result.HostInfo.Profile;

            var eventBranding = {
              desktopBanner: res.data.result.EventInfo.EventBanner
                ? res.data.result.EventInfo.EventBanner
                : "",
              mobileBanner: res.data.result.EventInfo.EventBannerMobile
                ? res.data.result.EventInfo.EventBannerMobile
                : "",
              shareBanner: res.data.result.EventInfo.EventBannerShare
                ? res.data.result.EventInfo.EventBannerShare
                : "",
            };
            if (
              !eventBranding.desktopBanner ||
              !eventBranding.mobileBanner ||
              !eventBranding.shareBanner
            ) {
              if (res.data.result.banner) {
                if (
                  !eventBranding.desktopBanner &&
                  res.data.result.banner["2048x88"]
                ) {
                  eventBranding.desktopBanner =
                    res.data.result.banner["2048x88"];
                }
                if (
                  !eventBranding.mobileBanner &&
                  res.data.result.banner["750x103"]
                ) {
                  eventBranding.mobileBanner =
                    res.data.result.banner["750x103"];
                }
                if (
                  !eventBranding.shareBanner &&
                  res.data.result.banner["1200x628"]
                ) {
                  eventBranding.shareBanner =
                    res.data.result.banner["1200x628"];
                }
              }
            }
            if (self.evntId != self.getEventId()) {
              bus.$emit("SetGuestBannerURL", eventBranding);
            }

            self.getButtonBranding(self.hostName);
            if (!self.visitor) {
              self.getCheckoutForms();
              //self.getTermsAndConditionsFields();

              /*if (self.getDynamicFields) {
                self.getDynamicFields();
              }*/
            }
          })
          .catch((error) => {
            console.error(
              "There was an error to read event branding: " + error
            );
            //self.showSnackbar("There was an error to read event branding: " + error, "error", "top");
          });
      })
      .catch((error) => {
        console.error("There was an error to read client branding: " + error);
        //self.showSnackbar("There was an error to read client branding: " + error, "error", "top");
      });

    //self.hideLoader();
    bus.$emit("toggleLoader", false);
    var testElements = document.getElementsByClassName("info");
    console.log("info" + testElements);
  },
  beforeDestroy() {
    //alert("beforeDestroy");
    if (eventStartTimerInterval) {
      clearInterval(eventStartTimerInterval);
    }
    if (countDownTimerInterval) {
      clearInterval(countDownTimerInterval);
    }
  },
  methods: {
    initScreen() {
      if (window.innerWidth > 768) {
        self.BannerURL = self.desktopBanner;
      } else {
        self.BannerURL = self.mobileBanner;
      }
    },
    setPhoneCode(data, pos) {
      if (data && data.formattedNumber) {
        this.DefaultFields[pos].PhoneCountryCode = data.countryCode;
        this.DefaultFields[pos].value = data.nationalNumber;
      }
    },
    CompleteClass(index) {
      var completeClass = "";
      if (
        index < self.FilledForms.length &&
        self.FilledForms[index].isComplete
      ) {
        completeClass = " complete";
      }
      return completeClass;
    },
    IsFormComplete(index) {
      var isComplete = false;
      if (
        index < self.FilledForms.length &&
        self.FilledForms[index].isComplete
      ) {
        isComplete = true;
      }
      return isComplete;
    },
    AddToCalendar(event, service) {
      return self.AddToEventCalendar(
        service,
        event.EventFullName,
        event.EventStartTimestamp,
        event.EventEndTimestamp,
        true
      );
    },
    ShowSocialShare() {
      if (self.EventsData.length > 0) {
        var shareEvent = new Object();
        shareEvent.ClientId = self.clientID;
        shareEvent.EventId = self.evntId;
        shareEvent.EventFullName = self.EventsData[0].EventFullName;
        shareEvent.Description = self.EventsData[0].Description;
        shareEvent.EventLogo = self.EventsData[0].EventLogo;
        shareEvent.EventBannerShare = self.EventsData[0].EventBannerShare;
        shareEvent.IsPublished = self.EventsData[0].IsPublished;
        bus.$emit("ShowSocialShare", shareEvent);
      }
    },
    //0D : 11H : 25M : 22S
    startEventStartCountDownTimer() {
      self.EventStartsIn = "";
      if (eventStartTimerInterval) {
        clearInterval(eventStartTimerInterval);
      }
      if (self.EventsData && self.EventsData.length > 0) {
        let countDownDate = self.EventsData[0].EventStartTimestamp * 1000;
        //countDownDate = new Date("2021-11-24T07:36:00").getTime();
        eventStartTimerInterval = setInterval(function () {
          // Get today's date and time
          let now = new Date().getTime();
          // Find the distance between now and the count down date
          let distance = countDownDate - now;
          if (distance > 0) {
            var result = "";
            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            if (days > 0) {
              result = days.toString() + "Day ";
            }
            //alert(days)
            let hours = Math.floor(
              (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            if (hours > 0) {
              result += hours.toString() + ":";
            }
            let minutes = Math.floor(
              (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            result += minutes.toString() + ":";
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);
            result += seconds > 9 ? seconds : "0" + seconds.toString();

            self.EventStartsIn = result;
          } else {
            //self.EventStartsIn = "Event started";
            self.EventStartsIn = null;
            clearInterval(eventStartTimerInterval);
          }
        }, 1000);
      }
    },
    startCountDownTimer() {
      self.countDownTimer = "";
      self.countDownTimerLabel = "";
      if (countDownTimerInterval) {
        clearInterval(countDownTimerInterval);
      }
      if (self.RegistrationTypes.length) {
        // each registration types form 1 min
        //let endTime = self.RegistrationTypes.length * 60 *1000;
        //let endTime = self.expiry;
        let countDownDate = new Date().getTime() + self.expiry * 60000;
        //countDownDate.setMinutes(endMin);
        //countDownDate = countDownDate.getTime() + endTime;
        // Update the count down every 1 second
        countDownTimerInterval = setInterval(function () {
          // Get today's date and time
          let now = new Date().getTime();
          // Find the distance between now and the count down date
          let distance = countDownDate - now;
          if (distance >= 0) {
            // Time calculations for days, hours, minutes and seconds
            //var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor(
              (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            let minutes = Math.floor(
              (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Display the result in the element with id="demo"
            // self.countDownTimer =
            //   hours + " Hr: " + minutes + " Min: " + seconds + " Sec ";
            self.countDownTimer = "";
            self.countDownTimerLabel = "";
            if (hours > 0) {
              self.countDownTimer = hours + ":";
              self.countDownTimerLabel = "HH:";
            }
            self.countDownTimer +=
              minutes +
              ":" +
              (seconds > 9 ? seconds : "0" + seconds.toString());
            self.countDownTimerLabel += "MM:SS";
          }
          if (distance > 9000 && distance < 10000) {
            self.showSnackbar(
              "Hurry, less than 10 seconds left!",
              "warning",
              "top"
            );
          }
          // If the count down is finished, write some text
          if (distance < 0) {
            clearInterval(countDownTimerInterval);
            // self.countDownTimer = null;
            // self.countDownTimerLabel = null;
            //self.CheckoutForm = null;
            self.NoFormText = "Time Over!";
            setTimeout(() => {
              if (self.$store.state.publicEventCollection) {
                router.push({
                  path: "/home",
                });
              } else {
                router.push({
                  path: "/eventv3/" + self.evntId,
                });
              }
            }, 3000);
          }
        }, 1000);
      }
    },
    GreatClicked(e) {
      debugger;
      if (self.visitor) {
        var timeout = 5000;
        if (e) {
          timeout = 1;
        }
        setTimeout(() => {
          self.redirectToLogin = true;
          self.showSnackbar("Loging in...", "success", "top");
        }, timeout);
      } else {
        if (self.auto_login && self.join_url) {
          location.href = self.join_url;
        } else {
          self.goForLandingPage();
        }
      }
    },
    initVisitorRegForm(regEventId) {
      self.evntId = regEventId;
      self.visitor = true;
    },
    PPPcanceled: function (res) {
      console.log(res);
      $("#payment-popup").modal("hide");
      alert("Payment not done!");
    },
    PPPcomplete: function (res) {
      console.log(res);
      $("#payment-popup").modal("hide");
      alert("Payment Successfull.");
    },
    checkout() {
      debugger;
      console.log(self.publishableKey);
      console.log("successurl - " + self.successUrl);
      console.log("CancelUrl- " + self.cancelUrl);

      // var dropRegType = document.getElementById("dropRegType");
      // var strRegtype = dropRegType.options[dropRegType.selectedIndex].value;
      if (!Number(self.checkoutPice)) {
        //if (strRegtype == "$0") {
        document.getElementById("dvOtherMsg").innerText =
          "Please select an option";
        $("#Othermsg-modal").modal("show");
        return false;
      } else {
        var spn = document.getElementById("spntotalPrice");
        spn.style.color = "red";

        document.getElementById("btnStripePayment").innerText =
          "Redirecting to stripe...";

        var key = {
          instanceId: "OA_UAT",
          clientId: self.clientID.toString(),
          eventId: parseInt(self.evntId.replace("E", "")),
        };
        console.log(JSON.stringify(key));
        self.clientReferenceId = JSON.stringify(key);
        // var email = document.getElementById("txtEmail").value;
        // self.customerEmail = email;
        self.customerEmail = self.FilledForms[0].Email;
        self.cancelUrl =
          location.origin +
          "/regpaymentFailure/" +
          self.evntId +
          "/" +
          self.FilledForms[0].Email;
        //self.lineItems[0].price = strRegtype;
        // self.lineItems[0].price = "pi_1HyGvDJy5CUjqeXaEqJCl9fC";
        //self.lineItems[0].price = "price_1HSf3tJy5CUjqeXayYUbMo6I";
        // self.lineItems.push({
        //   price: "price_1HSf4SJy5CUjqeXa1qWeZ3SZ",
        //   quantity: 1,
        // });
        self.lineItems = [];
        for (var i = 0; i < self.FilledForms.length; i++) {
          var priceId = "";
          if (
            self.FilledForms[i].RegistrationType &&
            self.FilledForms[i].RegistrationType.TicketPriceID
          ) {
            priceId = self.FilledForms[i].RegistrationType.TicketPriceID;
          }
          if (!priceId) {
            //priceId = "price_1HSf4SJy5CUjqeXa1qWeZ3SZ";
          }
          //console.log("priceId>>>>>>>>>>> " + priceId);
          var items = self.lineItems.filter(function (item) {
            return item.price == priceId;
          });
          if (items.length == 0) {
            self.lineItems.push({
              price: priceId,
              quantity: 1,
            });
          } else {
            items[0].quantity++;
          }
        }
        if (self.lineItems.length > 0) {
          setTimeout(() => {
            self.$refs.checkoutRef.redirectToCheckout();
          }, 2000);
        }
      }
    },
    getCheckoutForms: function () {
      debugger;
      var evntCol = "OA_UAT_" + self.clientID + self.evntId;
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objStaticFieldRef = storageRef.child(
        evntCol + "/Registration/CheckoutForms.JSON"
      );
      // var url =
      //   "https://resources.e2m.live/" +
      //   storageRef.bucket +
      //   "/" +
      //   evntCol +
      //   "/Registration/CheckoutForms.JSON";
      objStaticFieldRef
        .getDownloadURL()
        .then((url) => {
          axios
            .get(url)
            .then((response) => {
              self.response = response;
              self.CheckoutForms = response.data.CheckoutForms;
              if (response.data.Config) self.Config = response.data.Config;
              self.getStaticFieldSettings();
              self.startCountDownTimer();
              self.startEventStartCountDownTimer();
            })
            .catch((error) => {
              console.log("getCheckoutForms get: " + error);
              self.getCheckoutFormsRetryCount++;
              if (self.getCheckoutFormsRetryCount < 6) {
                self.getCheckoutForms();
              } else {
                self.goForLandingPage();
              }
              //alert("getCheckoutForms get: " + self.getCheckoutFormsRetryCount);
            });
        })
        .catch((error) => {
          console.log("getCheckoutForms getDownloadURL: " + error);
          self.getCheckoutFormsRetryCount++;
          if (self.getCheckoutFormsRetryCount < 6) {
            self.getCheckoutForms();
          } else {
            self.goForLandingPage();
          }
          // alert(
          //   "getCheckoutForms getDownloadURL: " +
          //     self.getCheckoutFormsRetryCount
          // );
        });
    },
    getStaticFieldSettings: function () {
      debugger;
      self.shortforCSSClass = "";
      //--------------------------------------------------------------------------
      self.CheckoutForm = null;
      self.DefaultFields = [];
      self.PreSignupFields = [];
      self.fields = [];
      //self.schema.fields = [];
      let RegistrationType = self.RegistrationTypes[self.ActiveRegIndex];
      if (!RegistrationType) {
        return false;
      }

      self.FormType = RegistrationType.FormType
        ? RegistrationType.FormType
        : "Free";
      debugger;
      var filledForm = null;
      if (self.FilledForms.length > self.ActiveRegIndex) {
        filledForm = self.FilledForms[self.ActiveRegIndex];
      }
      //------------ Checkout Forms Fields --------
      let formExists = self.CheckoutForms.some((checkForm) => {
        let formRegTypeExists = checkForm.RegistrationTypes.some((regType) => {
          if (
            RegistrationType.RegistrationTypeId == regType.RegistrationTypeId &&
            checkForm.IsPublished
          ) {
            if (
              !self.checkoutCurrency &&
              regType.Currency &&
              regType.Currency.symbol
            ) {
              self.checkoutCurrency = regType.Currency.symbol;
            }
            if (filledForm) {
              self.CheckoutForm = filledForm;
              self.DefaultFields = filledForm.DefaultFields;
              //self.PreSignupFields = filledForm.PreSignupFields;
              self.fields = filledForm.DynamicFields;
            } else {
              self.CheckoutForm = checkForm;
              self.DefaultFields = checkForm.DefaultFields;
              self.fields = checkForm.DynamicFields;
            }
            self.PreSignupFields = checkForm.PreSignupFields;
            if (checkForm.DynamicFields) {
              checkForm.DynamicFields.map((field) => {
                let df = {
                  id: field.cid,
                  type: "input",
                  inputType: field.field_type,
                  label: field.label,
                  model: field.cid.split(" ").join("").toLowerCase(),
                  placeholder: null,
                  readonly: false,
                  disabled: false,
                  featured: false,
                  required: field.required,
                  values: [],
                };
                if (field.field_options.options) {
                  field.field_options.options.filter((op) => {
                    df.values.push(op.label);
                  });
                }
                if ("radio" == field.field_type) df.type = "radios";
                else if ("checkboxes" == field.field_type)
                  df.type = "checklist";
                else if ("dropdown" == field.field_type) df.type = "select";
                self.schema.fields.push(df);
              });
            }

            //self.SubmitButtonText = checkForm.SubmitButtonDisplaylabel ? checkForm.SubmitButtonDisplaylabel : "Submit"
            // if (self.hostName.toLowerCase().indexOf("uat") > -1) {
            //   self.publishableKey = checkForm.TestPublishableKey
            //     ? checkForm.TestPublishableKey
            //     : null;
            // } else {
            //   self.publishableKey = checkForm.LivePublishableKey
            //     ? checkForm.LivePublishableKey
            //     : null;
            // }

            self.SubmitButtonText = self.Config.SubmitButtonDisplaylabel
              ? self.Config.SubmitButtonDisplaylabel
              : "Submit";
            self.publishableKey = "";
            if (self.Environment() == "prd") {
              if (self.Config.isTestModeEnabled == true) {
                if (self.Config.TestPublishableKey) {
                  self.publishableKey = self.Config.TestPublishableKey;
                }
              } else {
                if (self.Config.LivePublishableKey) {
                  self.publishableKey = self.Config.LivePublishableKey;
                }
              }
              //console.log("lk:- " + self.publishableKey);
            } else {
              if (self.Config.TestPublishableKey) {
                self.publishableKey = self.Config.TestPublishableKey;
              }
              //console.log("tk:- " + self.publishableKey);
            }

            //------------------------Payingto--------------------------------
            self.Payingto =
              checkForm.Payingto != undefined ? checkForm.Payingto : "";
            self.hostLogo =
              checkForm.PayingToLogo != undefined ? checkForm.PayingToLogo : "";
            self.PaymentSource = checkForm.PaymentSource
              ? checkForm.PaymentSource
              : "STRIPE";
            self.PaypalEnv = checkForm.PaypalEnv
              ? checkForm.PaypalEnv
              : "sandbox";
            self.PaypalCurrency = checkForm.PaypalCurrency
              ? checkForm.PaypalCurrency
              : "USD";
            self.PPcredentials = checkForm.PPcredentials
              ? checkForm.PPcredentials
              : null;
            console.log(self.CheckoutForm);
          }
        });
        if (!formRegTypeExists)
          self.NoFormText =
            "No Matching Form Available For This Registration Type!";
      });
      if (!formExists) self.NoFormText = "No Forms Available!";
    },

    setStates(obj) {
      //console.log(obj)
      self.States = obj.states ? obj.states : [];
    },
    onFileChange(input, fieldObj, maxSize) {
      console.log("inside====", input);
      self.userUpdated = false;
      self.attendeeUpdated = false;
      debugger;
      //var files = input;

      //for (var i = 0; i < files.length; i++) {
      var file = input;

      if (maxSize) {
        if (file.size < maxSize * 1024 * 1024) {
          var metadata = {
            contentType: file.type,
          };
          self.eventcollectionname = `OA_UAT_` + self.clientID + self.evntId;
          // const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
          // if (!validImageTypes.includes(file.type)) {
          //   alert("Only gif,jpeg & png file allowed.");
          //   return false;
          // }

          //self.showLoader();
          bus.$emit("toggleLoader", true);

          storageRef
            .storage()
            .ref()
            .child(
              self.eventcollectionname +
                "/Attendees/" +
                "REG" +
                "_" +
                new Date().getTime() +
                "_" +
                file.name
            )
            .put(file, metadata)
            .then(function (snapshot) {
              snapshot.ref
                .getDownloadURL()
                .then(function (fileURL) {
                  //self.hideLoader();
                  bus.$emit("toggleLoader", false);
                  console.log("inside==fileURL==", fileURL);
                  fieldObj.value = fileURL;
                  console.log("inside==fieldObj==", fieldObj);
                })
                .then(() => {
                  console.log("Successfully uploaded the Profile Picture");
                })
                .catch(() => {
                  //self.hideLoader();
                  bus.$emit("toggleLoader", false);
                  //alert("There was an error editing the profilepic: ");
                  self.showSnackbar(
                    "There was an error uploading the file",
                    "error",
                    "top"
                  );
                });
            })
            .catch(function () {
              //self.hideLoader();
              bus.$emit("toggleLoader", false);
              //alert("Profile Picture upload failed");
              self.showSnackbar("file upload failed", "error", "top");
            });
        }
      }

      // }
    },
    HideDropdown: function () {
      $("#checkboxes").hide();
      self.expanded = false;
    },
    goForLandingPage: function () {
      //  if (self.$refs.close_modal) {
      //    self.$refs.close_modal.click();
      //  }
      $("#success-modal").modal("hide");
      if (self.$store.state.publicEventCollection) {
        router.push({
          path: "/home",
        });
      } else if (this.IsSelfServiceEnabled() && this.isEventAdmin()) {
        router.push({
          path: "/admin-event/" + self.evntId,
        });
      } else {
        router.push({
          path: "/eventv3/" + self.evntId,
        });
      }
    },
    goForEventList: function () {
      //self.$refs.close_modal.click();
      $("#success-modal").modal("hide");
      router.push({
        path: "/register/" + self.clientID,
      });
    },
    goForLogin: function () {
      //self.$refs.close_modal.click();
      $("#success-modal").modal("hide");
      router.push({ name: "Login" });
    },
    getButtonBranding: function (hostName) {
      var path;
      if (hostName.toLowerCase().indexOf("uat") > -1) {
        path = "https://resources.e2m.live/uate2monair.appspot.com/";
      } else {
        path = APIs.googleSoragePath;
      }
      axios
        .get(
          path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
        )
        .then((res) => {
          debugger;
          self.btnBackColor = res.data.LoginAssets.loginButtonFillColor;
          self.btntextColor = res.data.LoginAssets.loginButtonTextColor;
          //$("#btnRegister").css("background-color", self.btnBackColor);
          //$("#btnRegister").css("color", self.btntextColor);

          $("#btnStripePayment").css("background-color", self.btnBackColor);
          $("#btnStripePayment").css("color", self.btntextColor);
        });
      //------------------------------------------------------------------------------
    },
    clearform: function () {
      /*if (confirm("Are you sure to clear the form?")) {
        var elements = document.getElementsByTagName("input");
        for (var ii = 0; ii < elements.length; ii++) {
          if (elements[ii].type == "text") {
            elements[ii].value = "";
          }
          if (elements[ii].type == "number") {
            elements[ii].value = "";
          }
          if (elements[ii].type == "email") {
            elements[ii].value = "";
          }
          if (elements[ii].type == "file") {
            elements[ii].value = "";
          }
          document.getElementById("dvspecialization").innerText = "Select One";
        }
        $('input[type="checkbox"]:checked').prop("checked", false);        
      }*/

      self.DefaultFields.map((item) => {
        item.value = null;
        item.Country = null;
        item.State = null;
        item.filevalue = null;
      });
      document.getElementById("regForm").reset();
      self.confirmEmail = "";
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    checkEmail: function (input, fieldIndex) {
      ///var email = document.getElementById("txtEmail").value;
      var email = input.target.value;
      document.getElementById("dvOtherMsg").innerText = "";
      if (email.trim() == "") {
        return false;
      }
      email = email.toLowerCase();
      if (!self.reg.test(email)) {
        // document.getElementById("dvOtherMsg").innerText =
        //   "Wrong email format, please enter proper email.";
        // $("#Othermsg-modal").modal("show");
        self.showSnackbar(
          "Wrong email format, please enter proper email.",
          "error",
          "top"
        );
        self.DefaultFields[fieldIndex].value = null;
        return false;
      }

      let duplicateEmail = false;
      for (let form of self.FilledForms) {
        if (email.trim() == form.Email.trim()) {
          duplicateEmail = true;
        }
      }
      if (duplicateEmail) {
        self.showSnackbar(
          "This email is already used in previous form!",
          "error",
          "top"
        );
        self.DefaultFields[fieldIndex].value = null;
        return false;
      }

      var postData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID.toString(),
          eventId: self.evntId,
        },
        data: {
          Email: email,
        },
      };
      //self.showLoader();
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.XAPIkey,
      };
      axios
        .post(APIs.CheckUserStatus, JSON.stringify(postData), {
          headers: headers,
        })
        .then((response) => {
          if (response.data.attendeeStatus) {
            //self.hideLoader();
            bus.$emit("toggleLoader", false);
            // document.getElementById("dvOtherMsg").innerText =
            //   "This email is already registered, please sign-up with a different email.";
            // $("#Othermsg-modal").modal("show");

            self.showSnackbar(
              "This email is already registered, please sign-up with a different email.",
              "error",
              "top"
            );
            self.DefaultFields[fieldIndex].value = null;
            return false;
          } else {
            //self.hideLoader();
            bus.$emit("toggleLoader", false);
          }
        })
        .catch((error) => {
          console.log(error);
          //self.hideLoader();
          bus.$emit("toggleLoader", false);
          self.showSnackbar("Something went wrong!", "error", "top");
          alert("Something went wrong!");
        });
    },
    gopreviousForm() {
      //self.ActiveRegIndex--;
      self.saveAndContinue(-1);
      //self.getStaticFieldSettings();
    },
    submitForms() {
      debugger;
      let IsformSaved = self.saveAndContinue(1);
      if (!IsformSaved) {
        return false;
      }
      self.NoFormText =
        self.FilledForms.length > 1
          ? "All Forms Submitted!"
          : "Form Submitted!";
      //console.log(self.FilledForms);
      /*if(Number(self.checkoutPice))
      {
         alert(`Total Payment = ${self.checkoutPice}`);
         $("#payment-popup").modal("show");
       }else{
         $("#success-modal").modal("show");
       }*/
      if (self.FilledForms.length) {
        self.SaveUserRegistration();
      }
    },
    GoToForm(index, save) {
      if (self.ActiveRegIndex == index) {
        return;
      }
      if (self.IsFormComplete(index)) {
        if (save) {
          self.saveAndContinue(0, index);
        } else {
          self.ActiveRegIndex = index;
          self.getStaticFieldSettings();
        }
      } else if (index == self.FilledForms.length) {
        self.ActiveRegIndex = index;
        self.getStaticFieldSettings();
        self.clearform();
      } else if (save) {
        self.saveAndContinue(1, index);
      }
    },
    saveAndContinue(direction, jumpToIndex) {
      var hasError = false;
      var errorText = "";
      // For Default Fields Validation
      //var form = { elements: [] };
      //var form = document.getElementById('regForm');

      for (var j = 0; j < this.DefaultFields.length; j++) {
        console.log("submit =====", self.DefaultFields[j]);

        if (
          self.DefaultFields[j].Mandatory &&
          self.DefaultFields[j].value == null
        ) {
          errorText = self.DefaultFields[j].Label + ` is mandatory field!`;
          hasError = true;
          break;
        }

        if (
          self.DefaultFields[j].Name == "Email" &&
          self.DefaultFields[j].Compare &&
          self.DefaultFields[j].value != null
        ) {

          if (!self.confirmEmail) {
            errorText =
              `Confirm ` + self.DefaultFields[j].Label + ` is mandatory field!`;
            hasError = true;
            break;
          } else if (self.confirmEmail != self.DefaultFields[j].value) {
            errorText =
              `Confirm ` + self.DefaultFields[j].Label +
              ` dosn't match with ` +
              self.DefaultFields[j].Label +
              `!`;

            hasError = true;
            break;
          }
        }
      }

      // self.DefaultFields.map((item) => {
      //   if (item.Mandatory && item.value == null) {
      //     errorText = item.Label + ` is mandatory field!`;

      //     hasError = true;
      //     break;
      //   }
      // });

      // form.elements = document.getElementsByClassName("defaultField");
      // for (let i = 0; i < form.elements.length; i++) {
      //   console.log("form====", form);

      //   if (
      //     [
      //       "text",
      //       "email",
      //       "file",
      //       "tel",
      //       "number",
      //       "select-one",
      //       "select-multiple",
      //     ].includes(form.elements[i].type) &&
      //     form.elements[i].value === "" &&
      //     form.elements[i].hasAttribute("required")
      //   ) {
      //     if (!hasError) {
      //       // document.getElementById(
      //       //   "dvOtherMsg"
      //       // ).innerText = `${form.elements[i].name} is mandatory field!`;
      //       // $("#Othermsg-modal").modal("show");
      //       let validationLabel = form.elements[i].dataset.validationlabel
      //         ? form.elements[i].dataset.validationlabel
      //         : form.elements[i].name;
      //       errorText = `${validationLabel} is mandatory field!`;

      //       hasError = true;
      //     }
      //     //return false;
      //   } else if (
      //     ["checkbox"].includes(form.elements[i].type) &&
      //     !form.elements[i].checked &&
      //     form.elements[i].hasAttribute("required")
      //   ) {
      //     if (!hasError) {
      //       // document.getElementById(
      //       //   "dvOtherMsg"
      //       // ).innerText = `${form.elements[i].name} is mandatory field!`;
      //       // $("#Othermsg-modal").modal("show");
      //       let validationLabel = form.elements[i].dataset.validationlabel
      //         ? form.elements[i].dataset.validationlabel
      //         : form.elements[i].name;
      //       errorText = `${validationLabel} is mandatory field!`;

      //       hasError = true;
      //     }
      //     //return false;
      //   } else if (
      //     form.elements[i].classList.contains("radioFields") &&
      //     form.elements[i].classList.contains("required")
      //   ) {
      //     let radios = form.elements[i].querySelectorAll("input[type=radio]");
      //     let checked = form.elements[i].querySelector(
      //       "input[type=radio]:checked"
      //     );
      //     if (!checked && !hasError) {
      //       let validationLabel = radios[0].dataset.validationlabel
      //         ? radios[0].dataset.validationlabel
      //         : radios[0].name;
      //       errorText = `${validationLabel} is mandatory field!`;
      //       hasError = true;
      //     }
      //     //return false;
      //   }
      // }

      let allInputs = [];
      let i = 0;
      for (var index in self.fields) {
        let field = self.fields[index];
        if (field.field_type != "checkboxes") {
          if (
            self.model[field.cid] != undefined &&
            self.model[field.cid] != "" &&
            self.model[field.cid].toLowerCase() != "select an option"
          ) {
            var input = {};
            if (field.field_type != "paragraph") {
              console.log("paragraph");
            }
            if (self.model[field.cid] != undefined) {
              input.label = field.label;
              input.des = field.field_options.description;
              input.options = field.field_options.options;
              input.field_type = field.field_type;
            }
            input.value = self.model[field.cid];
            input.index = i;
            i++;
            allInputs[field.cid] = input;
          } else {
            if (field.field_type != "paragraph") {
              if (field.required) {
                if (!hasError) {
                  var label = field.label;
                  // document.getElementById("dvOtherMsg").innerText =
                  //   label + " is mandatory.";
                  // $("#Othermsg-modal").modal("show");
                  errorText = document.getElementById("dvOtherMsg").innerText =
                    label + " is mandatory.";
                  hasError = true;
                }
                //return false;
              }
            }
          }
        } else {
          if (self.model[field.cid] == undefined) {
            if (field.required) {
              let label2 = field.label;
              if (!hasError) {
                // document.getElementById("dvOtherMsg").innerText =
                //   label2 + " is mandatory.";
                // $("#Othermsg-modal").modal("show");
                errorText = document.getElementById("dvOtherMsg").innerText =
                  label2 + " is mandatory.";
                hasError = true;
              }
              //return false;
            }
          } else if (self.model[field.cid].length <= 0) {
            if (field.required) {
              let label2 = field.label;
              if (!hasError) {
                // document.getElementById("dvOtherMsg").innerText =
                //   label2 + " is mandatory.";
                // $("#Othermsg-modal").modal("show");
                errorText = document.getElementById("dvOtherMsg").innerText =
                  label2 + " is mandatory.";
                hasError = true;
              }
              //return false;
            }
          } else {
            var input2 = {};

            if (field.field_type != "paragraph") {
              console.log("paragraph");
            }
            if (self.model[field.cid] != undefined) {
              input2.label = field.label;
              input2.des = field.field_options.description;
              input2.options = field.field_options.options;
              input2.field_type = field.field_type;
            }
            input2.value = self.model[field.cid];
            input2.index = i;
            i++;
            allInputs[field.cid] = input2;
          }
        }
      }

      if (self.PreSignupFields.HTMLbody) {
        if (!document.getElementById("chkTermsAndConditions").checked) {
          if (!hasError) {
            // document.getElementById(
            //   "dvOtherMsg"
            // ).innerText = `Accept Terms And Conditions`;
            // $("#Othermsg-modal").modal("show");
            errorText = document.getElementById(
              "dvOtherMsg"
            ).innerText = `Accept Terms And Conditions`;
            hasError = true;
          }
        }
        if (!hasError) {
          if (
            document.getElementById("chkOptInONE") &&
            document.getElementById("chkOptInONE").hasAttribute("required") &&
            !document.getElementById("chkOptInONE").checked
          ) {
            if (!hasError) {
              document.getElementById("dvOtherMsg").innerHTML =
                self.PreSignupFields.OptInOne;
              errorText =
                "Please accept: " +
                document
                  .getElementById("dvOtherMsg")
                  .innerText.substring(0, 30) +
                "...";
              hasError = true;
            }
          }
        }
      }

      let RegistrationType = self.RegistrationTypes[self.ActiveRegIndex];
      let postData = {
        sendMail: RegistrationType.FormType == "Paid" ? 1 : 1, //sendMail for Paid Ticket - test purpose
        ShowInCMSAttendeeList: RegistrationType.FormType == "Paid" ? 0 : 1,
        FormType: RegistrationType.FormType
          ? RegistrationType.FormType.toUpperCase()
          : "FREE",
        RegistrationType: {
          ColorCode: RegistrationType.ColorCode,
          RegistrationType: RegistrationType.RegistrationType,
          RegistrationTypeId: RegistrationType.RegistrationTypeId,
          TicketPriceID: RegistrationType.TicketPriceID,
        },
        DynamicFields: allInputs,
        DefaultFields: [],
        PreSignupFields: [],
      };
      if (RegistrationType.FormType == "Paid") {
        var objPayment = new Object();
        debugger;
        objPayment.Status = self.PaymentStatus;
        objPayment.TransactionId = "";
        objPayment.Amount = self.checkoutCurrency + self.ItemPrice;
        objPayment.Created = new Date();
        objPayment.Source = self.PaymentSource;
        postData.Payment = objPayment;
      }
      // self.DefaultFields.map(function (item) {
      //   var fieldObj = new Object();
      //   for (var key in item) {
      //     fieldObj[key] = item[key];
      //   }
      //   postData.DefaultFields.push(fieldObj);
      // });
      //postData.DefaultFields= [...self.DefaultFields];
      //postData.PreSignupFields= [...self.PreSignupFields];
      // DefaultFields: self.DefaultFields,
      // PreSignupFields: self.PreSignupFields,
      //self.CheckoutForms[self.ActiveRegIndex].DefaultFields = [...self.DefaultFields];

      self.DefaultFields.forEach((item) => {
        if (item.Type == "country&state") {
          postData["Country"] = item.Country ? item.Country.country : "";
          postData["State"] = item.State ? item.State : "";
        } else if (item.Type == "phone") {
          postData["PhoneCountryCode"] = item.PhoneCountryCode
            ? item.PhoneCountryCode
            : null;
          postData["Phone"] = item.value ? item.value : "";
        } else if (
          item.Type == "file" &&
          item.Category &&
          item.Category == "Profile Picture"
        ) {
          postData["ProfilePictureURL"] = item.value ? item.value : "";
        } else if (item.StaticField) {
          postData[item.Name] = item.value;
        } else if (item.IsPredefined) {
          postData[item.Name] = item.value;
        } else {
          if (!["group_title", "group_subtitle"].includes(item.Type)) {
            postData.DynamicFields.push({
              Name: item.Name,
              Value: item.value,
              Label: item.Label,
              Type: item.Type,
            });
          }
        }
      });

      debugger;
      if (!hasError) {
        postData.isComplete = true;
        if (self.FilledForms.length > self.ActiveRegIndex) {
          self.FilledForms[self.ActiveRegIndex] = postData;
        } else {
          self.FilledForms.push(postData);
        }
      } else {
        if (direction > 0) {
          self.showSnackbar(errorText, "error", "top");
          return false;
        }
      }

      if (direction < 0) {
        self.ActiveRegIndex--;
      } else if (direction > 0) {
        self.ActiveRegIndex++;
      } else {
        self.ActiveRegIndex = jumpToIndex;
      }
      self.getStaticFieldSettings();
      if (self.ActiveRegIndex + 1 > self.FilledForms.length) {
        self.clearform();
      }
      return true;
    },
    SaveUserRegistration: function () {
      //self.showLoader();
      console.log("FilledForms=====", self.FilledForms);

      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.XAPIkey,
      };
      let requestData = {
        postToCRM: self.postToCRM,
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.evntId,
          //bundleId: self.bundleId,
        },
        data: self.FilledForms,
      };
      var apiUrl = APIs.RegisterAttendee;
      if (self.auto_login) {
        apiUrl = APIs.RegisterAttendeeExt;
      } else {
        requestData.key.bundleId = self.bundleId;
      }
      axios
        .post(apiUrl, requestData, {
          headers: headers,
        })
        .then((response) => {
          debugger;
          let data = response.data;
          //self.hideLoader();
          bus.$emit("toggleLoader", false);
          //self.clearform();
          if (data.status == 0 && data.bundleId) {
            clearInterval(countDownTimerInterval);
            clearInterval(eventStartTimerInterval);
            if (Number(self.checkoutPice)) {
              $("#payment-popup").modal("show");
            } else {
              $("#success-modal").modal("show");
              if (self.visitor) {
                self.GreatClicked();
              } else {
                if (self.auto_login) {
                  self.join_url =
                    data.data.data[0].JoinURL +
                    "&redirect_url=" +
                    self.redirect_url;
                } else {
                  document
                    .getElementById("success-modal")
                    .addEventListener("click", function () {
                      self.GreatClicked();
                    });
                }
              }
            }
            return false;
          } else {
            var errorText = response.data.msg;
            var index = 0;
            if (data.data) {
              var flag = false;
              for (var i = 0; i < data.data.length; i++) {
                if (
                  data.data[i].ValidationStatus &&
                  data.data[i].ValidationStatus.status != 0
                ) {
                  for (var j = 0; j < self.FilledForms.length; j++) {
                    if (self.FilledForms[j].Email == data.data[i].Email) {
                      index = j;
                      errorText = data.data[i].ValidationStatus.msg;
                      flag = true;
                      break;
                    }
                    if (flag) {
                      break;
                    }
                  }
                }
              }
            }
            self.showSnackbar(errorText, "error", "top");
            self.GoToForm(index);
            // document.getElementById("dvOtherMsg").value =
            //   "An Unknown error has occurred, please try again later.";
            // $("#Othermsg-modal").modal("show");
            return false;
          }
        })
        .catch((error) => {
          //self.hideLoader();
          bus.$emit("toggleLoader", false);
          // document.getElementById("dvOtherMsg").value =
          //   "Error in registration process,please try again later. Error:" +
          //   error;
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            "Error in registration process,please try again later. Error:" +
              error,
            "error",
            "top"
          );
          return false;
        });
    },
    SaveUserRegistration_Backup: function () {
      //debugger;
      //self.showLoader();
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.XAPIkey,
      };
      let requestData = {
        postToCRM: self.postToCRM,
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.evntId,
        },
        data: self.FilledForms,
      };
      axios
        .post(APIs.RegisterEventAttendee, requestData, {
          headers: headers,
        })
        .then((response) => {
          let data = response.data;
          //self.hideLoader();
          bus.$emit("toggleLoader", false);
          self.clearform();
          if (data.status == 0 && data.bundleId) {
            if (Number(self.checkoutPice)) {
              $("#payment-popup").modal("show");
            } else {
              $("#success-modal").modal("show");
              if (self.visitor) {
                self.GreatClicked();
              }
            }
            return false;
          } else {
            // document.getElementById("dvOtherMsg").value =
            //   "An Unknown error has occurred, please try again later.";
            // $("#Othermsg-modal").modal("show");
            self.showSnackbar(
              "An Unknown error has occurred, please try again later.",
              "error",
              "top"
            );
            return false;
          }
        })
        .catch((error) => {
          //self.hideLoader();
          bus.$emit("toggleLoader", false);
          // document.getElementById("dvOtherMsg").value =
          //   "Error in registration process,please try again later. Error:" +
          //   error;
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            "Error in registration process,please try again later. Error:" +
              error,
            "error",
            "top"
          );
          return false;
        });
    },
    autoLoginAfterReg() {
      //alert(self.email);
      if (window.parent && $("#dialogReg", window.parent.document)) {
        $("#dialogReg", window.parent.document).attr("data-val", self.email);
        $("#dialogReg", window.parent.document).click();
      }
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      clearTimeout(self.timerLoader);
      if ($("#divLoading") != null) {
        $("#divLoading").hide();
      }
    },
  },
};
</script>
